import {addStyle} from "./svgHelper";
import layoutStyles from "./layoutStyles";
import "@babel/polyfill";
import * as d3 from "d3";
import {getKeyCode} from "./utils";

export default function (target, colors, pieData,options) {
    const width = 1024,
        height = 576,
        radius = (height + 50) / 2;
    //radius = Math.min(width, height) / 2;

    const margin = {left: 60, right: 60, bottom: 100, top: 150};
    if(options && options.margin){
        margin.top = options.margin.top || margin.top;
        margin.bottom = options.margin.bottom || margin.bottom;
        margin.left = options.margin.left || margin.left;
        margin.right = options.margin.right || margin.right;
    }
    drawBaseLayout(options);
    let svg;
    if(!options || !options.pie){
      svg = d3.select(target)
            .append("g")
            .attr("transform", "translate(" + (width - radius - margin.left - 5) + "," + 515 + ")"); // Group erstellen für die Zeichen Area
    }
    else{
       svg = d3.select(target)
            .append("g")
            .attr("transform", "translate(" + (options.pie.x + width - radius - margin.left - 5) + "," + options.pie.y + ")"); // Group erstellen für die Zeichen Area
    }

    function drawBaseLayout(options) {
        const svg = d3.select(target);
        const centerWidth = width - margin.left - margin.right;
        // BG

        if(!options || options.background) {
            svg.append('image')
                .attr("href", "resources/SWR_Aktuell_Logo_2Z_RGB_Weiss.svg")
                .attr("x", margin.left)
                .attr("y", 20)
                .attr("width", 100)
                .attr("height", 60);
            svg.style('background', 'rgb(206,211,217)')
                .style('background', 'linear-gradient(180deg, rgba(206,211,217,1) 0%, rgba(233,234,238,1) 50%, rgba(206,211,217,1) 100%)')
        }

        if(!options || !options.header){
            // Kicker
            let kickerPrefix = '';
            let kickerText = pieData.kicker;
            let kickerKeyword = 'bundestagswahl';
            if (pieData.kicker.toLowerCase().includes(kickerKeyword)) {
                const keyWordIndex = pieData.kicker.toLowerCase().indexOf(kickerKeyword);
                kickerPrefix = pieData.kicker.substring(keyWordIndex, kickerKeyword.length);
                kickerText = pieData.kicker.substring(kickerKeyword.length, pieData.kicker.length);
            }
            const kicker = svg.append("text")
                .attr("x", centerWidth + margin.left)
                .attr("y", margin.top - 80)
                .attr("text-anchor", 'end');

            kicker
                .append('tspan')
                .call(addStyle, layoutStyles.headline)
                .text(kickerPrefix);

            kicker.append('tspan')
                .style("font-weight", "400")
                .style("font-family", options.fontFamily || "TheMix")
                .style("font-size", "24px")
                .style("fill", "#00183a")
                .text(kickerText);

            svg
                .append("rect")
                .attr("x", margin.left)
                .attr("y", margin.top - 70)
                .attr("fill", "white")
                .attr("width", centerWidth)
                .attr("height", 2);
            // Subheadline
            const subHeader = svg
                .append("text")
                .style("font-weight", "400")
                .style("text-anchor", "start")
                .attr("x", margin.left)
                .attr("y", margin.top - 44)
                .attr("font-family", options.fontFamily || "TheMix")
                .attr("font-size", "20px")
                .attr("fill", "#00183a");

            subHeader.append("tspan")
                .style("font-weight", "700")
                .text("Koalitionsrechner: ")
            subHeader.append("tspan")
                .text(pieData.category + ' ' +pieData.headline + ' ' +pieData.infoText)

            svg.append("text")
                .style("font-weight", "400")
                .style("text-anchor", "middle")
                .attr("x", 640)
                .attr("y", margin.top + 20)
                .attr("font-family", options.fontFamily || "TheMix")
                .attr("font-size", "20px")
                .attr("fill", "#00183a")
                .text("Bitte Parteien auswählen");
            svg
                .append("rect")
                .attr("width", centerWidth)
                .attr("height", 5)
                .attr("x", margin.left)
                .attr("y", margin.top - 35)
                .attr("fill", "rgb(232, 82, 54)");
        }
        else{
            options.header.forEach(item=>{
                const el = svg.append(item.type)
                    .attr("width", item.width)
                    .attr("height", item.height)
                    .attr("x",item.x)
                    .attr("y", item.y)
                    .call(addStyle, item.style);
                if(item.type === 'text'){
                    if(item.render){
                        el.text(item.render(pieData));
                    }
                    else if(item.info){
                        el.text(item.text + pieData.infoText);
                    }
                    else{
                        el.text(item.text);
                    }
                }
            });
        }

        // Transparent BG
        if(!options || options.background) {
            svg
                .append("rect")
                .attr("width", centerWidth)
                .attr("height", height - margin.top - 30)
                .attr("x", margin.left)
                .attr("y", margin.top - 30)
                .attr("fill", "white")
                .style("opacity", 0.1);
        }
        else{
            svg
                .append("rect")
                .attr("width", centerWidth)
                .attr("height", height - margin.top - 30)
                .attr("x", margin.left)
                .attr("y", margin.top - 30)
                .attr("fill", "url(#MyGradient)");
        }

        if(pieData.createdTS.length){
            options.timestamp = options.timestamp ? options.timestamp : {label:{}};
            const time = svg.append('text')
                .style("font-weight",options.timestamp.fontWeight || "400")
                .style("text-anchor", "start")
                .style("font-family", options.fontFamily || "TheMix")
                .style("font-size", options.timestamp.fontSize || "14px")
                .style("fill", options.timestamp.color || "#00183a")
                .attr("x", options.timestamp.x || margin.left)
                .attr("y", options.timestamp.y || 553);
            time.append('tspan')
                .style('font-weight', options.timestamp.label.fontWeight || '800')
                .style("font-size", options.timestamp.label.fontSize || "14px")
                .text('Stand: ');
            time.append('tspan')
                .style("font-size", options.timestamp.fontSize || "14px")
                .text(pieData.createdTS);
        }


        if(!options.logo){
            if(pieData.source){
                const source = svg.append('text')
                    .style("font-weight", "400")
                    .style("text-anchor", "middle")
                    .style("font-family", options.fontFamily || "TheMix")
                    .style("font-size", "14px")
                    .style("fill", "#00183a")
                    .attr("x", margin.left + centerWidth / 2)
                    .attr("y", 553);
                source.append('tspan')
                    .style('font-weight', '800')
                    .style("font-size", "14px")
                    .text('Quelle: ');
                source.append('tspan')
                    .style("font-size", "14px")
                    .text(pieData.source)
            }
        }
        else{
            const sourceImage = options.logo;
            svg.append(sourceImage.type)
                .attr("x",sourceImage.x)
                .attr("y",sourceImage.y)
                .attr("href", sourceImage.href)
                .style("width",sourceImage.width)
                .style("width",sourceImage.height)
                .call(addStyle, sourceImage.style);
        }

        if(!options || !options.logo){
            svg.append('text')
                .style("font-weight", "400")
                .style("text-anchor", "start")
                .style("font-family", options.fontFamily || "TheMix")
                .style("font-size", "14px")
                .style("fill", "#00183a")
                .attr("x", margin.left + centerWidth - 160)
                .attr("y", 553)
                .text('infratest dimap')

            svg.append('image')
                .attr('href', 'resources/SWR_Logo_RGB_Weiss.svg')
                .attr("x", margin.left + centerWidth - 58)
                .attr("y", 540)
                .style("width", "auto")
                .style("height", "14px");
        }
       else{
            const sourceImage = options.source;
            svg.append(sourceImage.type)
                .attr("x",sourceImage.x)
                .attr("y",sourceImage.y)
                .attr("href", sourceImage.href)
                .style("width",sourceImage.width)
                .style("width",sourceImage.height)
                .call(addStyle, sourceImage.style ||{});
        }

    }

    //drawLedgend();
    svg.append("g").attr("class", "slices"); // group erstellen für die Slices des Charts
    function getValue(d) {
        return d.value;
    }

    function getKey(d) {
        return d.name;
    }


    var pie = d3.pie()
        .startAngle(-90 * (Math.PI / 180))
        .endAngle(90 * (Math.PI / 180))
        .sort(null)
        .value(function (d) {
            return d.value;
        }); // Pie Layout erstellen Halbkreis 180Grad

    var arc = d3.arc()
        .outerRadius(radius * 1.0)
        .innerRadius(radius * 0.4);

    svg.insert("path")
        .attr("class", "slice")
        .style("fill", 'transparent')
        .attr("stroke", "#FFF")
        .attr("stroke-width", 2)
        .style("stroke-opacity", 1)
        .attr("d", arc({startAngle: -Math.PI / 2, endAngle: Math.PI / 2}));
    var key = function (d) {
        return d.data.name;
    }; // um den key für ein datenelement zu holen

    drawCenter();
    drawLedgend();
    const empty = pieData.values.map(item => {
        return {...item, value: 0}
    });
    empty.push({name: 'rest', color: 'transparent', value: pieData.totalValue})
    update(empty); // das eigendliche rendern

    function drawLedgend() {
        const legend = pieData.values;
        const y = d3.scaleBand()
            .range([0, 390])
            .padding(0.1)
            .domain(legend.map(function (d) {
                return d.name;
            }));

        const svg = d3.select(target);
        const legendHeight = y.bandwidth();

        const defaultOffset = margin.top - 30 ;
        const textOffset = defaultOffset + legendHeight/2;
        if(options.brButtons){
            const groups = svg.selectAll('g.legendBar')
                .data(legend)
                .enter()
                .append('g')
                .attr('class', 'legendBar')
                .attr('aria-label', function (d) {
                    return d.name;
                })
                .attr('role', 'button')
                .attr('tabindex', 0)
                .attr('aria-pressed', false)
                .style("cursor", "pointer")
                .on('keydown', function (e, d) {
                    const code = getKeyCode(e);
                    if (code === 'Enter' || code === 13 || code === 'Space' || code === 32) {
                        e.preventDefault();
                        const pressed = e.currentTarget.getAttribute('aria-pressed') === 'true';
                        e.currentTarget.setAttribute('aria-pressed', !pressed);
                        const btnGroup = d3.select(this);
                        if(!this.toggle){
                            btnGroup.select('rect').style("fill", getColor(d.color));
                            btnGroup.selectAll('text, .seperator').style("fill", 'white');
                        }
                        else{
                            btnGroup.select('rect').style("fill", '#d9d9d9');
                            btnGroup.selectAll('text, .seperator').style("fill", getColor(d.color));
                        }
                        updateData(d.name, d.value, this,true,false)
                    }
                })
                .on("click", function (e, d) {
                    const pressed = e.currentTarget.getAttribute('aria-pressed') === 'true';
                    e.currentTarget.setAttribute('aria-pressed', !pressed);
                    const btnGroup = d3.select(this);
                    if(!this.toggle){
                        btnGroup.select('rect').attr("fill", getColor(d.color));
                        btnGroup.selectAll('text, .seperator').attr("fill", 'white');
                    }
                    else{
                        btnGroup.select('rect').attr("fill", '#d9d9d9');
                        btnGroup.selectAll('text, .seperator').attr("fill", getColor(d.color));
                    }
                    updateData(d.name, d.value, this,true,false)
                });
            groups.style("opacity", 1);

            groups.append("rect")
                .attr('rx', '0.5rem')
                .attr('ry', '0.5rem')
                .attr("x", function (d) {
                    return margin.left + 10;
                })
                .attr("y", function (d) {
                    return y(d.name) + defaultOffset ;
                })
                .attr("width", 200)
                .attr("height", legendHeight)
                .attr("fill", '#d9d9d9');

            groups.append("rect")
                .attr("class", "seperator")
                .attr("x", function (d) {
                    return margin.left + 10 + 120;
                })
                .attr("y", function (d) {
                    return y(d.name) + defaultOffset + 10;
                })
                .attr("width", 3)
                .attr("height", legendHeight - 20)
                .attr("fill", (d) => getColor(d.color));


            groups.append("text")
                .attr("class", "percent")
                .attr("x", function (d) {
                    return margin.left + 20
                })
                .attr("y", function (d) {
                    return y(d.name) + textOffset;
                })
                .attr("fill", (d) => getColor(d.color))
                .text(getKey);
            groups.append("text")
                .attr("class", "percent number")
                .attr("x", function (d) {
                    return margin.left + 50 + 120;
                })
                .attr("y", function (d) {
                    return y(d.name) + textOffset;
                })
                .style("text-anchor","middle")
                .attr("fill", (d) => getColor(d.color))
                .text(getValue);
        }
        else{
            const groups = svg.selectAll('g.legendBar')
                .data(legend)
                .enter()
                .append('g')
                .attr('class', 'legendBar')
                .attr('aria-label', function (d) {
                    return d.name;
                })
                .attr('role', 'button')
                .attr('tabindex', 0)
                .attr('aria-pressed', false)
                .style("cursor", "pointer")
                .style("opacity", 0.3)
                .on('keydown', function (e, d) {
                    const code = getKeyCode(e);
                    if (code === 'Enter' || code === 13 || code === 'Space' || code === 32) {
                        e.preventDefault();
                        const pressed = e.currentTarget.getAttribute('aria-pressed') === 'true';
                        e.currentTarget.setAttribute('aria-pressed', !pressed);
                        updateData(d.name, d.value, this);
                    }
                })
                .on("click", function (e, d) {
                    const pressed = e.currentTarget.getAttribute('aria-pressed') === 'true';
                    e.currentTarget.setAttribute('aria-pressed', !pressed);
                    updateData(d.name, d.value, this)
                });
            groups.append("rect")
                .attr("x", function (d) {
                    return margin.left
                })
                .attr("y", function (d) {
                    return y(d.name) + defaultOffset;
                })
                .attr("width", 20)
                .attr("height", legendHeight)
                .attr("fill", (d) => getColor(d.color));

            groups.append("rect")
                .attr("x", function (d) {
                    return margin.left + 20
                })
                .attr("y", function (d) {
                    return y(d.name) + defaultOffset;
                })
                .attr("width", 120)
                .attr("height", legendHeight)
                //.attr("fill", '#555')
                .call(addStyle, options.buttons && options.buttons.backgroundStyle || {});

            groups.append("text")
                .attr("class", "percent")
                .attr("x", function (d) {
                    return margin.left + 20 + 60
                })
                .attr("y", function (d) {
                    return y(d.name) + textOffset;
                })
                .call(addStyle, layoutStyles.labels)
                .style('fill', '#FFF')
                .text(getKey);

            groups.append("rect")
                .attr("x", function (d) {
                    return margin.left + 20 + 120 + 10
                })
                .attr("y", function (d) {
                    return y(d.name) + defaultOffset;
                })
                .attr("width", 60)
                .attr("height", legendHeight)
                .attr("fill", '#FFFFFF');

            groups.append("text")
                .attr("class", "percent number")
                .attr("x", function (d) {
                    return margin.left + 20 + 120 + 10 + 30
                })
                .attr("y", function (d) {
                    return y(d.name) + textOffset;
                })
                .call(addStyle, layoutStyles.labels)
                .text(getValue);
        }
    }

    function drawCenter() {
        svg.selectAll(".center").remove()
        var coords = getXYPos(0, 0, radius, -(Math.PI / 2));
        svg.append("line")
            .attr("class", "center")
            .attr("x1", 0)
            .attr("y1", -125)
            .attr("x2", coords.x)
            .attr("y2", coords.y)
            .attr("stroke", "#FFF")
            .attr("stroke-width", 3)
            .attr("stroke-dasharray", "10, 5")
    }

    /* setInterval(function () {
         update(makeData());
     }, 2000);*/

    function updateData(key, value, btn, toggleBtn = true,opa= true) {
        var found = empty.find(item => item.name === key);
        if(toggleBtn){
            btn.toggle = !btn.toggle;
            found.value = btn.toggle ? value : 0;
            if(opa){
                d3.select(btn).style("opacity", btn.toggle ? "1" : "0.3");
            }
        }
        rest();
        update(empty);
        drawCenterText(500);
    }

    var sum = 0;

    function drawCenterText(duration) {
        var newSum = empty.reduce((acc, item) => item.name !== 'rest' ? acc += item.value : acc, 0);
        var interp = d3.interpolateRound(sum, newSum);
        sum = newSum;
        svg.select('#centerText').remove();
        svg.select('#centerText2').remove();
        svg.append("text")
            .attr("id", 'centerText')
            .style("font-weight", "500")
            .style("text-anchor", "middle")
            .attr("x", 0)
            .attr("y", -40)
            .attr("font-family", options.fontFamily || "TheMix")
            .attr("font-size", "24px")
            .attr("font-weight", "600")
            .attr("fill", "#00183a")
            .call(addStyle, options.centerStyle || {})
            .transition()
            .duration(duration)
            .textTween(function () {
                return function (t) {
                    return interp(t) + " Sitze";
                };
            });

        // TODO still buggy
        const majority = Math.floor(pieData.totalValue / 2) + 1;
        const seats_result = Math.abs(majority - newSum);
        let centerText2 = `Keine Mehrheit (-${seats_result})`;
        if(newSum > majority ){
            centerText2 = `Mehrheit erreicht (+${seats_result})`
        }
        else if(newSum === majority ){
            centerText2 = `Mehrheit erreicht`;
        }
        svg.append("text")
            .attr("id", 'centerText2')
            .style("font-weight", "500")
            .style("text-anchor", "middle")
            .attr("x", 0)
            .attr("y", -40 + 24)
            .attr("font-family", options.fontFamily || "TheMix")
            .attr("font-size", "16px")
            .attr("font-weight", "600")
            .attr("fill", "#00183a")
            .call(addStyle, options.centerStyle || {})
            .transition()
            .duration(duration)
            .text(centerText2);

    }

    /**
     *
     * @param cx origin x
     * @param cy origin y
     * @param r radius
     * @param a angle
     */
    function getXYPos(cx, cy, r, a) {
        return {
            x: cx + r * Math.cos(a),
            y: cy + r * Math.sin(a)
        }
    }

    function rest() {
        var sum = empty.reduce((acc, item) => acc += item.value, 0);
        var rest = empty.find(item => item.name === 'rest');
        if (sum < pieData.totalValue) {
            rest.value += pieData.totalValue - sum;
        } else {
            rest.value -= sum - pieData.totalValue;
        }
    }

    function update(data, duration = 500) {
        var oldData = svg.select(".slices")
            .selectAll("path")
            .data().map(function (d) {
                return d.data
            });

        if (oldData.length === 0) oldData = data;
        var slice = svg.select(".slices")
            .selectAll("path")
            .data(pie(oldData), key);

        slice.enter()
            .insert("path")
            .attr("class", "slice")
            .style("fill", function (d) {
                return getColor(d.data.color);
            })
            .attr("stroke", "none")
            .attr("stroke-width", 2)
            .style("opacity", function (d) {
                return d.data.name === 'rest' ? 0.1 : 1;
            })
            .each(function (d) {
                this._current = d;
            });

        slice = svg.select(".slices")
            .selectAll("path")
            .data(pie(data), key);

        slice.transition()
            .duration(duration)
            .attrTween("d", function (d) {
                var interpolate = d3.interpolate(this._current, d);
                var _this = this;
                return function (t) {
                    _this._current = interpolate(t);
                    return arc(_this._current);
                };
            });
    }

    function getColor(color) {
        return colors[color];
    }

    window.koaEmpty = [...empty];
    window.updateKoa = update;
}
